var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-component":"teaserSkeletonElement","data-skeleton-type":_vm.type}},[_c('div',{attrs:{"data-skeleton-image":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-skeleton-content":""}},[_c('div',{attrs:{"data-skeleton-subline":"title"}}),_c('div',{attrs:{"data-skeleton-subline":"meta1"}}),_c('div',{attrs:{"data-skeleton-subline":"meta2"}})])
}]

export { render, staticRenderFns }